export const TOKEN = {
    TOKEN: {
        url: '/resourceActionTokens/:uuid',
        queryKey: 'getToken'
    },
    UPDATE: {
        url: '/users/update'
    }
};